import { Injectable } from '@angular/core'

import { Observable } from "rxjs";
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { Product } from '../entities/product.entities'

import { FirebaseApp } from 'angularfire2';
@Injectable()

export class ProductService {

    // Set Type Value Firebase 
    items: FirebaseListObservable<Product[]>;
    private products: Product[]
    private image;
    constructor(private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {
    }
    getProductRever() {
        this.items = this.af.list('product').map((array) => array.reverse()) as FirebaseListObservable<any[]>;;
        this.items
        return this.items;
    }
    getProduct() {
        this.items = this.af.list('product');
        this.items
        return this.items;
    }
    findProductID(id: string): Product {
        let tmpitem: Product;
        this.items = this.af.list('product');
        this.items.subscribe(snap => {
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].id == id) {
                    tmpitem = snap[i];
                }
            }
        })
        return tmpitem
    }
    findProductIndex(id: string): Product {
        let tmpitem: Product;
        this.items = this.af.list('product');
        this.items.subscribe(snap => {
            tmpitem = snap[id];
        })
        return tmpitem
    }
    findLenght(value: string) {
        this.items = this.af.list('product');
        let index = 0;
        this.items.subscribe(snap => {
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].type == value) {
                    index++;
                    //console.log(index)
                }
            }
        })
        return index
    }
    getLenght() {
        let leng: number;
        this.items = this.af.list('product');
        this.items.subscribe(snap => {
            leng = snap.length
        })
        return leng
    }
    removeProduct(id) {
        let itemRemove;
        let removeproduct = this.af.list('product');
        removeproduct.subscribe((snap) => {
            itemRemove = snap[id]
        })
        let rmv = this.af.list('/product');
        rmv.remove(itemRemove)
        alert("ลบสินค้าเสร็จสิ้น")
    }
    updateProduct(dataItem, idd) {
        let itemTmp;
        let updateData = this.af.list('/product')
        updateData.subscribe((snap) => {
            itemTmp = snap[idd]
        })
        updateData.update(itemTmp, dataItem).then((success) => {
            alert("แก้ไขเสร็จสิ้น")
        })
    }
    UpdateProductWithImage(dataItem, idd) {
        let itemTmp;
        let updateData = this.af.list('/product')
        updateData.subscribe((snap) => {
            itemTmp = snap[idd]
        })
        updateData.update(itemTmp, dataItem).then((success) => {
            alert("แก้ไขเสร็จสิ้น")
        })
    }


    UpdateData(id, url, type) {
        let itemTmp;
        let updateData = this.af.list('/product')
        updateData.subscribe((snap) => {
            itemTmp = snap[id]
        })
        if (type == '1') {
            updateData.update(itemTmp, { photo1: url }).then((success) => {
                alert("Edit Success")
            })
        }else if(type == '2'){
            updateData.update(itemTmp, { photo2: url }).then((success) => {
                alert("Edit Success")
            })
        }else if(type == '3'){
            updateData.update(itemTmp, { photo3: url }).then((success) => {
                alert("Edit Success")
            })
        }
    }

}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/product.service.ts